<template>
<div class="access">
  <div class="access__container">
    <h1 class="access__title">ACCESO</h1>
    <p class="access__text">Ingresa tu email y contraseña</p>
    <form class="form" @submit.prevent="login">
      <div class="form__fieldset">
        <div class="form__container form__container--wide">
          <label for="email" class="form__label">Email</label>
          <input type="text" class="form__input" name="email" id="email" v-model="element.email" v-validate="validation.email">
          <span v-show="errors.has('email')" class="form__alert">{{ errors.first('email') }}</span>
        </div>
        <div class="form__container form__container--wide">
          <label for="password" class="form__label">Password</label>
          <input type="password" class="form__input" name="password" id="password" v-model="element.password" v-validate="validation.password">
          <span v-show="errors.has('password')" class="form__alert">{{ errors.first('password') }}</span>
        </div>
        <input type="submit" class="btn btn__default btn--regular" value="Ingresar">
        <router-link class="btn btn__transparent btn--regular" :to="{name: 'recovery'}">Olvide mi Contraseña</router-link>
      </div>
    </form>
  </div>
</div>
</template>

<script>
import httpService from '@/api/request'
import {auth} from '@/assets/js/libs/sessions'
export default {
  mixins: [httpService],
  data: function () {
    return {
      element: {
        email: null,
        password: null
      },
      validation: {
        email: 'required|email',
        password: 'required|min:6'
      }
    }
  },
  methods: {
    login: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                module: 'login',
                element: this.element,
                params: ''
              }
              this.post(httpRequest)
                .then(
                  login => {
                    auth.setSession(login)
                      .then(
                        response => {
                          this.$store.commit('login')
                          this.$store.commit('notificate', {
                            title: 'LOGIN CORRECTO',
                            text: 'Ha iniciado sesión de forma correcta.',
                            type: 'success'
                          })
                          this.$router.push({name: 'home'})
                        }
                      )
                  }
                )
                .catch(
                  () => {
                    this.$store.commit('logout')
                    this.$store.commit('notificate', {
                      title: 'LOGIN INCORRECTO',
                      text: 'Ha ocurrido un error al intentar iniciar sesión, por favor, intente de nuevo.',
                      type: 'error'
                    })
                  }
                )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/_access"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/access/login.vue